import React from 'react'
import { ClinTheme } from '../../../../ClinTheme'
import { ClinText } from '../../../../components/ClinText'
import { StorageConstants } from '../ProductDetail.models'
import { StorageLabel, StyledStorageContainer } from './Storage.styles'

interface StorageComponent {
  storage?: string
}

const Storage: React.FC<StorageComponent> = ({ storage }) => {
  const storageColors: {
    [key: string]: { backgroundColor: string; textColor: string }
  } = {
    [StorageConstants.VeryCold]: {
      backgroundColor: ClinTheme.colors.lightBlue,
      textColor: ClinTheme.colors.tealishBlue
    },
    [StorageConstants.Cold]: {
      backgroundColor: ClinTheme.colors.deliveryDateBackground,
      textColor: ClinTheme.colors.primaryLight
    },
    [StorageConstants.Warm]: {
      backgroundColor: ClinTheme.colors.lightenGreen,
      textColor: ClinTheme.colors.deepGreen
    },
    [StorageConstants.VeryWarm]: {
      backgroundColor: ClinTheme.colors.lightenGreen,
      textColor: ClinTheme.colors.deepGreen
    }
  }

  const { backgroundColor, textColor } =
    storage && storageColors[storage]
      ? storageColors[storage]
      : {
          backgroundColor: 'rgba(117, 117, 117, 0.1)',
          textColor: ClinTheme.colors.darkGrey
        }

  const renderStorageLabel = (backgroundColor: string, textColor: string) => (
    <StorageLabel backgroundColor={backgroundColor}>
      <ClinText
        whiteSpace="nowrap"
        fontWeight={ClinTheme.fontWeights.medium}
        color={textColor}
        textAlign="center"
        fontSize={ClinTheme.fontSizes[0]}
        lineHeight={ClinTheme.lineHeights.largeParagraph}
        display="flex"
      >
        {storage} &#176;C
      </ClinText>
    </StorageLabel>
  )

  return (
    <StyledStorageContainer>
      {renderStorageLabel(backgroundColor, textColor)}
    </StyledStorageContainer>
  )
}

export default Storage
